<!--
 * @Author: wangxb 18254141586@163.com
 * @Date: 2023-11-24 10:18:43
 * @LastEditors: wangxb 18254141586@163.com
 * @LastEditTime: 2023-12-08 13:44:06
 * @FilePath: \ui-jfgjgl-v2\src\views\dataBoard\components\project\overall.vue
 * @Description:
-->
<template>
  <div class="board-container">
    <div class="board-panel">
      <div class="board-panel__header">
        汇总数据
      </div>
      <div class="board-panel__body">
        <div class="board-flex">
          <div class="board-flex__item row-1-col-3">
            <div class="data-item">
              <div class="data-item__value c-c18d1f">{{statisticsInfo.projectNum}}</div>
              <div class="data-item__title">项目总数（个）</div>
            </div>
            <div class="data-item">
              <div class="data-item__value c-c18d1f">{{statisticsInfo.executeProjectNum}}</div>
              <div class="data-item__title">执行中项目数（个）</div>
            </div>
            <div class="data-item">
              <div class="data-item__value c-c18d1f">{{statisticsInfo.endProjectNum}}</div>
              <div class="data-item__title">已结案项目数（个）</div>
            </div>
          </div>
          <div class="board-flex__item row-1-col-1">
            <div class="data-item">
              <div class="data-item__value c-1dfbd1 f-20">￥{{statisticsInfo.projectIncomeAmount | formatMoney}}</div>
              <div class="data-item__title f-14">项目总收入（含税）</div>
            </div>
          </div>
          <div class="board-flex__item row-1-col-1">
            <div class="data-item">
              <div class="data-item__value c-1dfbd1 f-20">￥{{statisticsInfo.projectIncomeAmountExcludingTaxes | formatMoney}}</div>
              <div class="data-item__title f-14">项目总收入（不含税）</div>
            </div>
          </div>
          <div class="board-flex__item row-1-col-1">
            <div class="data-item">
              <div class="data-item__value c-427fdc f-20">￥{{statisticsInfo.projectCostAmount | formatMoney}}</div>
              <div class="data-item__title f-14">项目成本费用总额</div>
            </div>
          </div>
          <div class="board-flex__item row-1-col-2">
            <div class="data-item">
              <div class="data-item__value c-7442dc">￥{{statisticsInfo.projectTotalProfit | formatMoney}}</div>
              <div class="data-item__title">项目总利润</div>
            </div>
            <div class="data-item">
              <div class="data-item__value c-7442dc">{{statisticsInfo.projectAvgProfit}}%</div>
              <div class="data-item__title">平均利润率</div>
            </div>
          </div>
        </div>
        <div class="board-flex">
          <div class="board-flex__item row-3-col-1 no-flex">
            <div class="board-col">
              <div class="board-col__header">
                迄今回款数据
              </div>
              <div class="board-col__body">
                <div class="board-col-data">
                  <div class="board-col-data__chart">
                    <el-progress type="dashboard"
                                 :stroke-width="14"
                                 :percentage="statisticsInfo.planCollection.incomeProportion"
                                 stroke-linecap="square"
                                 color="#427fdc"></el-progress>
                    <div class="chart-label">收入占比</div>
                  </div>
                  <div class="board-col-data__summary">
                    <div class="data-item">
                      <div class="data-item__value col-c-white">￥{{statisticsInfo.planCollection.amount | formatMoney}}</div>
                      <div class="data-item__title">计划回款总额</div>
                    </div>
                  </div>
                </div>
                <div class="board-col-data">
                  <div class="board-col-data__chart">
                    <div class="line-progress">
                      <div class="line-progress__label">计划占比</div>
                      <div class="line-progress__content">
                        <el-progress :text-inside="true"
                                     :stroke-width="14"
                                     color="#427fdc"
                                     :percentage="statisticsInfo.actualCollection.planProportion"></el-progress>
                      </div>
                    </div>
                    <div class="line-progress">
                      <div class="line-progress__label">收入占比</div>
                      <div class="line-progress__content">
                        <el-progress :text-inside="true"
                                     :stroke-width="14"
                                     color="#ff9f1b"
                                     :percentage="statisticsInfo.actualCollection.incomeProportion"></el-progress>
                      </div>
                    </div>
                  </div>
                  <div class="board-col-data__summary">
                    <div class="data-item">
                      <div class="data-item__value col-c-white">￥{{statisticsInfo.actualCollection.amount | formatMoney}}</div>
                      <div class="data-item__title">实际回款额度</div>
                    </div>
                  </div>
                </div>
                <div class="board-col-data">
                  <div class="board-col-data__chart">
                    <el-progress type="dashboard"
                                 :stroke-width="14"
                                 :percentage="statisticsInfo.receivableNoCollection.planProportion"
                                 stroke-linecap="square"
                                 color="#1dfbd1"></el-progress>
                    <div class="chart-label">计划占比</div>
                  </div>
                  <div class="board-col-data__summary">
                    <div class="data-item">
                      <div class="data-item__value col-c-white">￥{{statisticsInfo.receivableNoCollection.amount | formatMoney}}</div>
                      <div class="data-item__title">应收未回款总额</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="board-flex__item no-flex">
            <div class="board-flex">
              <div class="board-flex__item row-1-col-1-3">
                <div class="data-item">
                  <div class="data-item__value c-427fdc">￥{{statisticsInfo.projectGrossProfitAmount | formatMoney}}</div>
                  <div class="data-item__title">项目毛利总额（迄今）</div>
                </div>
              </div>
              <div class="board-flex__item row-1-col-1-3">
                <div class="data-item">
                  <div class="data-item__value c-427fdc">￥{{statisticsInfo.projectCashProfitAmount | formatMoney}}</div>
                  <div class="data-item__title">现金净利润总额（迄今）</div>
                </div>
              </div>
              <div class="board-flex__item row-1-col-1-3">
                <div class="data-item">
                  <div class="data-item__value c-427fdc">￥{{statisticsInfo.projectNextStagePayAmount | formatMoney}}</div>
                  <div class="data-item__title">下阶段应付费用总额（迄今）</div>
                </div>
              </div>
            </div>
            <div class="board-flex mt-16">
              <div class="board-flex__item row-2-col-1  no-flex">
                <div class="board-col">
                  <div class="board-col__header">
                    迄今开票数据
                  </div>
                  <div class="board-col__body">
                    <div class="board-col-data">
                      <div class="board-col-data__chart">
                        <el-progress type="dashboard"
                                     :stroke-width="14"
                                     :percentage="statisticsInfo.invoicing.incomeProportion"
                                     stroke-linecap="square"
                                     color="#427fdc"></el-progress>
                        <div class="chart-label">收入占比</div>
                      </div>
                      <div class="board-col-data__summary">
                        <div class="data-item">
                          <div class="data-item__value col-c-white">￥{{statisticsInfo.invoicing.amount | formatMoney}}</div>
                          <div class="data-item__title">已开票总额</div>
                        </div>
                      </div>
                    </div>
                    <div class="board-col-data">
                      <div class="board-col-data__chart">
                        <el-progress type="dashboard"
                                     :stroke-width="14"
                                     :percentage="statisticsInfo.invoicingNoCollection.incomeProportion"
                                     stroke-linecap="square"
                                     color="#427fdc"></el-progress>
                        <div class="chart-label">收入占比</div>
                      </div>
                      <div class="board-col-data__summary">
                        <div class="data-item">
                          <div class="data-item__value col-c-white">￥{{statisticsInfo.invoicingNoCollection.amount | formatMoney}}</div>
                          <div class="data-item__title">已开票未回总额</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="board-flex__item row-2-col-1  no-flex">
                <div class="board-col">
                  <div class="board-col__header">
                    迄今收票数据
                  </div>
                  <div class="board-col__body">
                    <div class="board-col-data">
                      <div class="board-col-data__chart">
                        <el-progress type="dashboard"
                                     :stroke-width="14"
                                     :percentage="statisticsInfo.invoice.contractProportion"
                                     stroke-linecap="square"
                                     color="#c18d1f"></el-progress>
                        <div class="chart-label">合同出款占比</div>
                      </div>
                      <div class="board-col-data__summary">
                        <div class="data-item">
                          <div class="data-item__value col-c-white">￥{{statisticsInfo.invoice.amount | formatMoney}}</div>
                          <div class="data-item__title">已收票总额</div>
                        </div>
                      </div>
                    </div>
                    <div class="board-col-data">
                      <div class="board-col-data__chart">
                        <el-progress type="dashboard"
                                     :stroke-width="14"
                                     :percentage="statisticsInfo.invoiceUndistributed.contractProportion"
                                     stroke-linecap="square"
                                     color="#c18d1f"></el-progress>
                        <div class="chart-label">合同出款占比</div>
                      </div>
                      <div class="board-col-data__summary">
                        <div class="data-item">
                          <div class="data-item__value col-c-white">￥{{statisticsInfo.invoiceUndistributed.amount | formatMoney}}</div>
                          <div class="data-item__title">已收票未支总额</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="board-flex__item row-3-col-1 no-flex">
            <div class="board-col">
              <div class="board-col__header">
                迄今支出数据
              </div>
              <div class="board-col__body">
                <div class="board-col-data">
                  <div class="board-col-data__chart">
                    <el-progress type="dashboard"
                                 :stroke-width="14"
                                 :percentage="statisticsInfo.planExpend.expendProportion"
                                 stroke-linecap="square"
                                 color="#1dfbd1"></el-progress>
                    <div class="chart-label">支出占比</div>
                  </div>
                  <div class="board-col-data__summary">
                    <div class="data-item">
                      <div class="data-item__value col-c-white">￥{{statisticsInfo.planExpend.amount | formatMoney}}</div>
                      <div class="data-item__title">计划支出总额</div>
                    </div>
                  </div>
                </div>
                <div class="board-col-data">
                  <div class="board-col-data__chart">
                    <div class="line-progress">
                      <div class="line-progress__label">计划占比</div>
                      <div class="line-progress__content">
                        <el-progress :text-inside="true"
                                     :stroke-width="14"
                                     color="#427fdc"
                                     :percentage="statisticsInfo.actualExpend.planProportion"></el-progress>
                      </div>
                    </div>
                    <div class="line-progress">
                      <div class="line-progress__label">收入占比</div>
                      <div class="line-progress__content">
                        <el-progress :text-inside="true"
                                     :stroke-width="14"
                                     color="#ff9f1b"
                                     :percentage="statisticsInfo.actualExpend.expendProportion"></el-progress>
                      </div>
                    </div>
                  </div>
                  <div class="board-col-data__summary">
                    <div class="data-item">
                      <div class="data-item__value col-c-white">￥{{statisticsInfo.actualExpend.amount | formatMoney}}</div>
                      <div class="data-item__title">实际支出额度</div>
                    </div>
                  </div>
                </div>
                <div class="board-col-data">
                  <div class="board-col-data__chart">
                    <el-progress type="dashboard"
                                 :stroke-width="14"
                                 :percentage="statisticsInfo.unexpendedExpend.planProportion"
                                 stroke-linecap="square"
                                 color="#1dfbd1"></el-progress>
                    <div class="chart-label">计划占比</div>
                  </div>
                  <div class="board-col-data__summary">
                    <div class="data-item">
                      <div class="data-item__value col-c-white">￥{{statisticsInfo.unexpendedExpend.amount | formatMoney}}</div>
                      <div class="data-item__title">应支未出总额</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="board-panel">
      <div class="board-panel__header">
        具体项目列表数据
      </div>
      <div class="board-panel__body table-content">
        <el-table :data="tableData"
                  ref="detailTable"
                  size="mini"
                  :summary-method="getSummaryMethod"
                  border
                  fit
                  show-summary
                  class="board-table"
                  height="95%"
                  stripe
                  header-row-class-name="board-table-header"
                  style="width: 100%">
          <el-table-column prop="projectCode"
                           show-overflow-tooltip
                           label="项目编号"
                           align="center"
                           width="120">
          </el-table-column>
          <el-table-column prop="projectName"
                           align="center"
                           min-width="200"
                           show-overflow-tooltip
                           label="项目名称">
          </el-table-column>
          <el-table-column prop="implementationDeptName"
                           show-overflow-tooltip
                           align="center"
                           width="100"
                           label="实施部门">
          </el-table-column>
          <el-table-column prop="projectLeader"
                           show-overflow-tooltip
                           align="center"
                           width="100"
                           label="项目负责人">
          </el-table-column>
          <el-table-column prop="projectStartDate"
                           show-overflow-tooltip
                           align="center"
                           width="120"
                           label="项目开始日期">
          </el-table-column>
          <el-table-column prop="projectAmount"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="140"
                           label="项目收入（含税）">
            <template slot-scope="scope">
              ￥{{scope.row.projectAmount | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="projectIncomeAmountExcludingTaxes"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="140"
                           label="项目收入（不含税）">
            <template slot-scope="scope">
              ￥{{scope.row.projectIncomeAmountExcludingTaxes | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="projectTotalProfit"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="140"
                           label="项目利润">
            <template slot-scope="scope">
              ￥{{scope.row.projectTotalProfit | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="projectTotalProfitRate"
                           show-overflow-tooltip
                           align="center"
                           width="90"
                           label="项目利润率">
            <template slot-scope="scope">
              {{scope.row.projectTotalProfitRate }}%
            </template>
          </el-table-column>
          <el-table-column prop="occupyAmount"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="140"
                           label="资金占用额（预计）">
            <template slot-scope="scope">
              ￥{{scope.row.occupyAmount | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="planCollection"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="140"
                           label="计划回款额（迄今）">
            <template slot-scope="scope">
              ￥{{scope.row.planCollection | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="actualCollectionAmount"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="140"
                           label="实际回款额（迄今）">
            <template slot-scope="scope">
              ￥{{scope.row.actualCollectionAmount | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="actualCollectionAmountExcludingTaxes"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="170"
                           label="实际回款额（迄今不含税）">
            <template slot-scope="scope">
              ￥{{scope.row.actualCollectionAmountExcludingTaxes | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="receivableNoCollectionAmount"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="140"
                           label="应收未回额（迄今）">
            <template slot-scope="scope">
              ￥{{scope.row.receivableNoCollectionAmount | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="invoicingAmount"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="140"
                           label="已开票额（迄今）">
            <template slot-scope="scope">
              ￥{{scope.row.invoicingAmount | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="invoicingNoCollectionAmount"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="170"
                           label="已开票未回金额（迄今）">
            <template slot-scope="scope">
              ￥{{scope.row.invoicingNoCollectionAmount | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="projectCostAmount"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="140"
                           label="项目成本费用合计">
            <template slot-scope="scope">
              ￥{{scope.row.projectCostAmount | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="planExpendAmount"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="140"
                           label="计划支出额（迄今）">
            <template slot-scope="scope">
              ￥{{scope.row.planExpendAmount | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="actualExpendAmount"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="140"
                           label="实际支出额（迄今）">
            <template slot-scope="scope">
              ￥{{scope.row.actualExpendAmount | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="actualExpendAmountExcludingTaxes"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="170"
                           label="实际支出额（迄今不含税）">
            <template slot-scope="scope">
              ￥{{scope.row.actualExpendAmountExcludingTaxes | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="unexpendedExpendAmount"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="150"
                           label="应支未出金额（迄今）">
            <template slot-scope="scope">
              ￥{{scope.row.unexpendedExpendAmount | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="contractExpendAmount"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="140"
                           label="合同出款额（迄今）">
            <template slot-scope="scope">
              ￥{{scope.row.contractExpendAmount | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="contractExpendAmountExcludingTaxes"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="170"
                           label="合同出款额（迄今不含税）">
            <template slot-scope="scope">
              ￥{{scope.row.contractExpendAmountExcludingTaxes | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="reimbursementAmount"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="140"
                           label="费用报销额（迄今）">
            <template slot-scope="scope">
              ￥{{scope.row.reimbursementAmount | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="laborCostAmount"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="140"
                           label="人工成本（迄今）">
            <template slot-scope="scope">
              ￥{{scope.row.laborCostAmount | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="invoiceAmount"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="140"
                           label="已收票额（迄今）">
            <template slot-scope="scope">
              ￥{{scope.row.invoiceAmount | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="invoiceUndistributedAmount"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="160"
                           label="已收票未支金额（迄今）">
            <template slot-scope="scope">
              ￥{{scope.row.invoiceUndistributedAmount | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="projectGrossProfitAmount"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="140"
                           label="项目毛利额（迄今）">
            <template slot-scope="scope">
              ￥{{scope.row.projectGrossProfitAmount | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="projectNextStagePayAmount"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="140"
                           label="下阶段应付费用">
            <template slot-scope="scope">
              ￥{{scope.row.projectNextStagePayAmount | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="projectCashProfitAmount"
                           show-overflow-tooltip
                           header-align="center"
                           align="right"
                           width="140"
                           label="现金净利润（迄今）">
            <template slot-scope="scope">
              ￥{{scope.row.projectCashProfitAmount | formatMoney}}
            </template>
          </el-table-column>
        </el-table>
        <div class="table-page">
          <el-pagination background
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         layout="total, sizes, prev, pager, next"
                         :current-page.sync="currentPage"
                         :page-sizes="[10,20,30,40,50,60,70,80,90,100]"
                         :page-size="pageParams.size"
                         popper-class="custom-page-sizes-popper-class"
                         :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOverallProjectStatisticsData, getOverallProjectStatisticsDetail } from '@/api/dataBoard'
import { toThousands } from '@/utils/tools'
export default {
  data() {
    return {
      searchParams: {},
      statisticsInfo: {
        actualCollection: {
          amount: 0,
          incomeProportion: 0,
          planProportion: 0
        },
        actualExpend: {
          amount: 0,
          expendProportion: 0,
          planProportion: 0
        },
        actualExpendAmountDetails: {},
        endProjectNum: 0,
        executeProjectNum: 0,
        invoice: {
          amount: 0,
          contractProportion: 0
        },
        invoiceUndistributed: {
          amount: 0,
          contractProportion: 0
        },
        invoicing: {
          amount: 0,
          incomeProportion: 0
        },
        invoicingNoCollection: {
          amount: 0,
          incomeProportion: 0
        },
        planCollection: {
          amount: 0,
          incomeProportion: 0
        },
        planExpend: {
          amount: 0,
          expendProportion: 0
        },
        projectAvgProfit: 0,
        projectCashProfitAmount: 0,
        projectCostAmount: 0,
        projectGrossProfitAmount: 0,
        projectIncomeAmount: 0,
        projectIncomeAmountExcludingTaxes: 0,
        projectNextStagePayAmount: 0,
        projectNum: 0,
        projectTotalProfit: 0,
        receivableNoCollection: {
          amount: 0,
          planProportion: 0
        },
        unexpendedExpend: {
          amount: 0,
          planProportion: 0
        }
      },
      pageParams: {
        current: 1,
        size: 30
      },
      total: 0,
      currentPage: 1,
      tableData: [],
      allTotal: {},
      currentPageTotal: {}
    }
  },
  methods: {
    /**
     * @Description: 加载数据内容
     * @param {*} searchParams
     * @return {*}
     */
    initPage(searchParams) {
      this.searchParams = searchParams
      this.pageParams.current = 1
      this.currentPage = 1
      this.loadStatisticsData()
      this.loadStatisticsDataDetail()
    },
    /**
     * @Description: 获取汇总数据
     * @return {*}
     */
    loadStatisticsData() {
      getOverallProjectStatisticsData(this.searchParams).then(res => {
        if (res.success) {
          this.statisticsInfo = res.obj
        } else {
          this.$notify.error({
            title: '错误',
            message: res.message
          })
        }
      })
    },
    /**
     * @Description: 获取列表数据
     * @return {*}
     */
    loadStatisticsDataDetail() {
      getOverallProjectStatisticsDetail(this.pageParams, this.searchParams).then(res => {
        if (res.success) {
          this.tableData = res.obj.detailList.records
          this.allTotal = res.obj.allTotal
          this.currentPageTotal = res.obj.currentPageTotal
          this.total = res.obj.detailList.total
          this.$nextTick(() => {
            this.$refs.detailTable.doLayout()
          })
        } else {
          this.$notify.error({
            title: '错误',
            message: res.message
          })
        }
      })
    },
    /**
     * @Description: table底部合计
     * @param {*} columns
     * @return {*}
     */
    getSummaryMethod({ columns }) {
      const { allTotal, currentPageTotal } = this
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = <div class="countClass"><div class="count_row">小计</div><div class="count_row">合计</div></div>
          return
        }

        sums[index] = <div class="countClass"><div class="count_row"></div><div class="count_row"></div></div>
        if (column.property === 'projectAmount' ||
          column.property === 'projectIncomeAmountExcludingTaxes' ||
          column.property === 'projectTotalProfit' ||
          column.property === 'occupyAmount' ||
          column.property === 'planCollection' ||
          column.property === 'actualCollectionAmount' ||
          column.property === 'actualCollectionAmountExcludingTaxes' ||
          column.property === 'receivableNoCollectionAmount' ||
          column.property === 'invoicingAmount' ||
          column.property === 'invoicingNoCollectionAmount' ||
          column.property === 'projectCostAmount' ||
          column.property === 'planExpendAmount' ||
          column.property === 'actualExpendAmount' ||
          column.property === 'actualExpendAmountExcludingTaxes' ||
          column.property === 'unexpendedExpendAmount' ||
          column.property === 'contractExpendAmount' ||
          column.property === 'contractExpendAmountExcludingTaxes' ||
          column.property === 'reimbursementAmount' ||
          column.property === 'laborCostAmount' ||
          column.property === 'invoiceAmount' ||
          column.property === 'invoiceUndistributedAmount' ||
          column.property === 'projectGrossProfitAmount' ||
          column.property === 'projectNextStagePayAmount' ||
          column.property === 'projectCashProfitAmount') {
          const subSum = `￥${toThousands(currentPageTotal[column.property])}`
          const totalSum = `￥${toThousands(allTotal[column.property])}`
          sums[index] = <div class="countClass"><div class="count_row">{subSum}</div><div class="count_row">{totalSum}</div></div>
        }
      })
      return sums
    },
    /**
     * @Description: 分页 没有条数改变
     * @param {*} val
     */
    handleSizeChange(val) {
      this.$refs.detailTable.bodyWrapper.scrollTop = 0
      this.pageParams.size = val
      this.pageParams.current = 1
      this.currentPage = 1
      this.loadStatisticsDataDetail()
    },
    /**
     * @Description: 分页 页码改变
     * @param {*} val
     */
    handleCurrentChange(val) {
      this.$refs.detailTable.bodyWrapper.scrollTop = 0
      this.pageParams.current = val
      this.loadStatisticsDataDetail()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/dataBoard.scss";
</style>
